<template>
    <div>
        <div class="b-banner-box">
            <div class="b-banner-titlebg">
                <div class="b-banner-title">数字化营销解决方案</div>
            </div>
        </div>
        <div class="rd-title">打造全渠道私域流量池</div>
        <div class="rd-title2">全渠道多场景营销，通过微信、短信、电商、门店POS、APP、邮件等不同营销触点，多渠道数据贯通，</div>
        <div class="rd-title2">实现客户旅程的自动化跟进，并进行个性化内容营销，实现企业与客户的真正有效沟通，促进业务增长。</div>
        <div class="rd-title3" style="margin-top: 60px;margin-bottom: 44px;">全渠道</div>
        <div class="rd-channel1-box">
            <div class="rd-channel1-boxc">
                <div class="rd-channel1-z">
                    <div class="rd-channel1-boxcimg">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-base-t1.png" alt="">
                    </div>
                    <div>社交</div>
                </div>
                <div class="rd-channel1-hoverBox rd-channel1-f">
                    <div style="margin-bottom: 18px;">社交</div>
                    <div class="rd-channel1-hoverBoxc">微生态</div>
                    <div class="rd-channel1-hoverBoxc">裂变</div>
                </div>
            </div>
            <div class="rd-channel1-boxc">
                <div class="rd-channel1-z">
                    <div class="rd-channel1-boxcimg">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-base-t2.png" alt="">
                    </div>
                    <div>内容</div>
                </div>
                <div class="rd-channel1-hoverBox rd-channel1-f">
                    <div style="margin-bottom: 18px;">内容</div>
                    <div class="rd-channel1-hoverBoxc">软文</div>
                    <div class="rd-channel1-hoverBoxc">问卷</div>
                </div>
            </div>
            <div class="rd-channel1-boxc">
                <div class="rd-channel1-z">
                    <div class="rd-channel1-boxcimg">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-base-t3.png" alt="">
                    </div>
                    <div>官网</div>
                </div>
                <div class="rd-channel1-hoverBox rd-channel1-f">
                    <div style="margin-bottom: 18px;">官网</div>
                    <div class="rd-channel1-hoverBoxc">官网埋码</div>
                    <div class="rd-channel1-hoverBoxc">行为数据</div>
                </div>
            </div>
            <div class="rd-channel1-boxc">
                <div class="rd-channel1-z">
                    <div class="rd-channel1-boxcimg">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-base-t4.png" alt="">
                    </div>
                    <div>会议</div>
                </div>
                <div class="rd-channel1-hoverBox rd-channel1-f">
                    <div style="margin-bottom: 18px;">会议</div>
                    <div class="rd-channel1-hoverBoxc">会前会中会后</div>
                    <div class="rd-channel1-hoverBoxc">线上线下</div>
                </div>
            </div>
            <div class="rd-channel1-boxc">
                <div class="rd-channel1-z">
                    <div class="rd-channel1-boxcimg">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-base-t5.png" alt="">
                    </div>
                    <div>第三方渠道</div>
                </div>
                <div class="rd-channel1-hoverBox rd-channel1-f">
                    <div style="margin-bottom: 18px;">第三方渠道</div>
                    <div class="rd-channel1-hoverBoxc">系统对接</div>
                    <div class="rd-channel1-hoverBoxc">智能分析</div>
                </div>
            </div>
            <div class="rd-channel1-boxc">
               <div class="rd-channel1-z">
                   <div class="rd-channel1-boxcimg">
                       <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-base-t6.png" alt="">
                   </div>
                   <div>邮件</div>
               </div>
                <div class="rd-channel1-hoverBox rd-channel1-f">
                    <div style="margin-bottom: 18px;">邮件</div>
                    <div class="rd-channel1-hoverBoxc">欢迎试</div>
                    <div class="rd-channel1-hoverBoxc">激活式</div>
                </div>
            </div>
            <div class="rd-channel1-boxc">
                <div class="rd-channel1-z">
                    <div class="rd-channel1-boxcimg">
                        <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-base-t1.png" alt="">
                    </div>
                    <div>销售</div>
                </div>
                <div class="rd-channel1-hoverBox rd-channel1-f">
                    <div style="margin-bottom: 18px;">销售</div>
                    <div class="rd-channel1-hoverBoxc">来源</div>
                    <div class="rd-channel1-hoverBoxc">转化</div>
                </div>
            </div>
        </div>
        <div class="rd-title3" style="margin-top: 60px;margin-bottom: 100px;">统一线索池（全渠道数据打通、整合）</div>
        <div class="rd-unified-box">
            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-unified-t1.png" alt="">
            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-unified-t2.png" alt="">
            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-unified-t3.png" alt="">
        </div>

        <div class="rd-tabbgf">
            <div class="rd-tabbg" :class="isfiex?'isfiex':''">
                <div class="rd-tab">
                    <a href="#member" :class="index == 0?'rd-tabc-s':''" class="rd-tabc">
                        <span>会员管理</span>
                        <div :class="index == 0?'rd-tabc-s':''" class="rd-tabcline"></div>
                    </a>
                    <a href="#integral" :class="index == 1?'rd-tabc-s':''" class="rd-tabc">
                        <span>积分管理</span>
                        <div :class="index == 1?'rd-tabc-s':''" class="rd-tabcline"></div>
                    </a>
                    <a href="#coupon" :class="index == 2?'rd-tabc-s':''" class="rd-tabc">
                        <span>优惠券管理</span>
                        <div :class="index == 2?'rd-tabc-s':''" class="rd-tabcline"></div>
                    </a>
                    <a href="#promotion" :class="index == 3?'rd-tabc-s':''" class="rd-tabc">
                        <span>促销管理</span>
                        <div :class="index == 3?'rd-tabc-s':''" class="rd-tabcline"></div>
                    </a>
                    <a href="#accurate" :class="index == 4?'rd-tabc-s':''" class="rd-tabc">
                        <span>精准营销</span>
                        <div :class="index == 4?'rd-tabc-s':''" class="rd-tabcline"></div>
                    </a>
                </div>
            </div>
        </div>
        <div style="width: 100%;height: 60px;" id="member"></div>
        <div class="rd-swiper" >
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide >
                        <div class="rd-swiper-slide">
                            <div class="rd-swiper-slide-l">
                                <div class="rd-swiper-slide-l-title">会员管理</div>
                                <div class="rd-swiper-slide-l-title2">全渠道触点 统一的会员管理体系和视图</div>
                                <div class="rd-swiper-slide-l-info">
                                    <div class="rd-swiper-slide-l-infoc">统一的会员分级机制和经验值管理体系</div>
                                    <div class="rd-swiper-slide-l-infoc">建立会员权益体系</div>
                                    <div class="rd-swiper-slide-l-infoc">完善忠诚度计划和积分体系</div>
                                    <div class="rd-swiper-slide-l-line">
                                        <div class="rd-swiper-slide-l-r" style="position:relative;top: -5px;">
                                            <div class="rd-swiper-slide-l-rn"></div>
                                        </div>
                                        <div class="rd-swiper-slide-l-r">
                                            <div class="rd-swiper-slide-l-rn"></div>
                                        </div>
                                        <div class="rd-swiper-slide-l-r" style="position:relative;bottom: -5px;">
                                            <div class="rd-swiper-slide-l-rn"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="rd-swiper-slide-r">
                                <div class="rd-swiper-slide-rdpc" style="margin-bottom: 56px;">
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t1.png" alt="">
                                        <div>积分商城</div>
                                    </div>
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t2.png" alt="">
                                        <div>消费有礼</div>
                                    </div>
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t3.png" alt="">
                                        <div>生日有礼</div>
                                    </div>
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t4.png" alt="">
                                        <div>节日有礼</div>
                                    </div>
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t5.png" alt="">
                                        <div>签到有礼</div>
                                    </div>
                                </div>
                                <div class="rd-swiper-slide-rdpc">
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t1.png" alt="">
                                        <div>充值有礼</div>
                                    </div>
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t2.png" alt="">
                                        <div>积分抵现</div>
                                    </div>
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t3.png" alt="">
                                        <div>开卡有礼</div>
                                    </div>
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t4.png" alt="">
                                        <div>等级折扣</div>
                                    </div>
                                    <div class="rd-swiper-slide-c">
                                        <img style="margin-bottom: 20px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-t5.png" alt="">
                                        <div>升级有礼</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </swiper-slide>
            </swiper>
            <img class="rd-member-prve" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-prve.png" alt="">
            <img class="rd-member-next" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-next.png" alt="">
        </div>
        <div style="width: 100%;height: 60px;" id="integral"></div>
        <div class="rd-integral" >
            <div class="rd-title">积分管理</div>
            <div class="rd-title2">全渠道统一的积分管理体系 提升客户忠诚度 支持多品牌 多合作伙伴及异业积分兑换</div>
            <div class="rd-integral-c">
                <div class="rd-integral-c-box">
                    <div class="rd-integral-c-boximg">
                        <img class="rd-integral-c-boximg-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t1.png" alt="">
                        <img class="rd-integral-c-boximg-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t1r.png" alt="">
                    </div>
                    <div>忠诚度计划</div>
                </div>
                <div class="rd-integral-c-box">
                    <div class="rd-integral-c-boximg">
                        <img class="rd-integral-c-boximg-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t2.png" alt="">
                        <img class="rd-integral-c-boximg-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t2r.png" alt="">
                    </div>
                    <div>会员层级管理</div>
                </div>
                <div class="rd-integral-c-box">
                    <div class="rd-integral-c-boximg">
                        <img class="rd-integral-c-boximg-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t3.png" alt="">
                        <img class="rd-integral-c-boximg-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t3r.png" alt="">
                    </div>
                    <div>积分池管理</div>
                </div>
                <div class="rd-integral-c-box">
                    <div class="rd-integral-c-boximg">
                        <img class="rd-integral-c-boximg-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t4.png" alt="">
                        <img class="rd-integral-c-boximg-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t4r.png" alt="">
                    </div>
                    <div>积分模型</div>
                </div>
                <div class="rd-integral-c-box">
                    <div class="rd-integral-c-boximg">
                        <img class="rd-integral-c-boximg-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t5.png" alt="">
                        <img class="rd-integral-c-boximg-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t5r.png" alt="">
                    </div>
                    <div>积分发行</div>
                </div>
            </div>
            <div class="rd-integral-c rd-integral-c2">
                <div class="rd-integral-c-box">
                    <div class="rd-integral-c-boximg">
                        <img class="rd-integral-c-boximg-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t6.png" alt="">
                        <img class="rd-integral-c-boximg-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t6r.png" alt="">
                    </div>
                    <div>积分结算</div>
                </div>
                <div class="rd-integral-c-box">
                    <div class="rd-integral-c-boximg">
                        <img class="rd-integral-c-boximg-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t7.png" alt="">
                        <img class="rd-integral-c-boximg-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t7r.png" alt="">
                    </div>
                    <div>会员积分履历</div>
                </div>
                <div class="rd-integral-c-box">
                    <div class="rd-integral-c-boximg">
                        <img class="rd-integral-c-boximg-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t8.png" alt="">
                        <img class="rd-integral-c-boximg-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t8r.png" alt="">
                    </div>
                    <div>积分累计</div>
                </div>
                <div class="rd-integral-c-box">
                    <div class="rd-integral-c-boximg">
                        <img class="rd-integral-c-boximg-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t9.png" alt="">
                        <img class="rd-integral-c-boximg-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-integral-t9r.png" alt="">
                    </div>
                    <div>积分兑换</div>
                </div>
            </div>
        </div>

        <div style="width: 100%;height: 60px;" id="coupon"></div>
        <div class="rd-coupon">
            <div class="rd-title">优惠券管理</div>
            <div class="rd-title2">全渠道统一的实体与虚拟优惠券管理体系 跟踪优惠券的库存、发放、核销历史</div>
            <div class="rd-coupon-box">
                <div class="rd-coupon-boxc">
                    <img class="rd-coupon-boxcimg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-coupon-t1.png" alt="">
                    <div>优惠券库存管理</div>
                </div>
                <div class="rd-coupon-boxc">
                    <img class="rd-coupon-boxcimg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-coupon-t2.png" alt="">
                    <div>优惠券生成管理</div>
                </div>
                <div class="rd-coupon-boxc">
                    <img class="rd-coupon-boxcimg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-coupon-t3.png" alt="">
                    <div>优惠券发放管理</div>
                </div>
                <div class="rd-coupon-boxc">
                    <img class="rd-coupon-boxcimg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-coupon-t4.png" alt="">
                    <div>优惠券核销管理</div>
                </div>
                <div class="rd-coupon-boxc">
                    <img class="rd-coupon-boxcimg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-coupon-t5.png" alt="">
                    <div>优惠券回收管理</div>
                </div>
                <div class="rd-coupon-boxc">
                    <img class="rd-coupon-boxcimg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-coupon-t6.png" alt="">
                    <div>优惠券历史</div>
                </div>
            </div>
            <div style="text-align: center">
                <img class="rd-coupon-b" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-coupon-b.png" alt="">
            </div>
        </div>

        <div style="width: 100%;height: 60px;margin-top: 90px;" id="promotion"></div>
        <div class="rd-promotion">
            <div class="rd-title">促销管理</div>
            <div class="rd-title2">支持全渠道全场景的促销引擎</div>
            <div style="width: 1240px;margin: 0 auto;">
                <div class="rd-promotion-tbox">
                    <div class="rd-promotion-tboxc">
                        <div class="rd-promotion-tboximg">
                            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-t1.png" alt="">
                        </div>
                        <div>线下POS</div>
                    </div>
                    <div class="rd-promotion-tboxc">
                        <div class="rd-promotion-tboximg">
                            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-t2.png" alt="">
                        </div>
                        <div>APP</div>
                    </div>
                    <div class="rd-promotion-tboxc">
                        <div class="rd-promotion-tboximg">
                            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-t3.png" alt="">
                        </div>
                        <div>Wechat</div>
                    </div>
                    <div class="rd-promotion-tboxc">
                        <div class="rd-promotion-tboximg">
                            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-t4.png" alt="">
                        </div>
                        <div>PC  Web</div>
                    </div>
                    <div class="rd-promotion-tboxc">
                        <div class="rd-promotion-tboximg">
                            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-t5.png" alt="">
                        </div>
                        <div>3rd Party</div>
                    </div>
                    <div class="rd-promotion-tboxc">
                        <div class="rd-promotion-tboximg">
                            <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-t6.png" alt="">
                        </div>
                        <div>B2B</div>
                    </div>
                </div>
                <div class="rd-promotion-tbox-title">
                    <div>全渠道</div>
                    <img style="margin: 10px 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-arrow.png" alt="">
                </div>
            </div>
            <div class="rd-promotion-infobox">
                <div class="rd-promotion-infobox-l">
                    <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-l.png" alt="">
                    <div>管理后台</div>
                </div>
                <div class="rd-promotion-infobox-m">
                    <div class="rd-promotion-infobox-m-title">促销引擎（计算器）</div>
                    <div class="rd-promotion-infobox-m-cbox">
                        <div class="rd-promotion-infobox-m-c">促销信息展示</div>
                        <div class="rd-promotion-infobox-m-c">促销筛选匹配</div>
                        <div class="rd-promotion-infobox-m-c">促销最优推荐</div>
                        <div class="rd-promotion-infobox-m-c">促销结果计算</div>
                    </div>
                    <div class="rd-promotion-infobox-m-cbox">
                        <div class="rd-promotion-infobox-m-c">锁/解锁账户</div>
                        <div class="rd-promotion-infobox-m-c">查询用户信息</div>
                        <div class="rd-promotion-infobox-m-c">促销分摊</div>
                        <div class="rd-promotion-infobox-m-c">第三方平台促销翻译</div>
                    </div>
                    <div class="rd-promotion-infobox-m-cbox">
                        <div class="rd-promotion-infobox-m-c2">Store Master Data Subscription</div>
                        <div class="rd-promotion-infobox-m-c2">Product Master Data Subscripton</div>
                    </div>
                </div>
                <img style="transform: rotate(90deg);margin-left: 22px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-arrow.png" alt="">
                <img style="margin-left: 27px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-r.png" alt="">
            </div>
            <div class="rd-promotion-infob">
                <div class="rd-promotion-infob-box" style="position:relative;right: 50px;">
                    <img style="margin: 10px 0;transform: rotate(180deg)" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-arrow.png" alt="">
                    <div class="rd-promotion-infob-boxtext">门店主数据</div>
                    <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-b1.png" alt="">
                </div>
                <div class="rd-promotion-infob-box" style="margin-left: 80px;">
                    <img style="margin: 10px 0;transform: rotate(180deg)" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-arrow.png" alt="">
                    <div class="rd-promotion-infob-boxtext">产品主数据</div>
                    <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-promotion-b2.png" alt="">
                </div>
            </div>
        </div>

        <div style="width: 100%;height: 60px;margin-top: 90px;" id="accurate"></div>
        <div class="rd-accurate">
            <div class="rd-title">精准营销</div>
            <div class="rd-title2" style="margin-bottom: 100px;">多维度获取用户数据，建立360度用户画像，精准个性化营销，提升产品销量</div>
            <div class="rd-accurate-box">
                <div class="rd-accurate-boxl">
                    <img style="margin-right: 120px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-accurate-t1.png" alt="">
                    <img  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-accurate-t2.png" alt="">
                    <img style="margin-top: 37px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-accurate-t3.png" alt="">
                </div>
                <div class="rd-accurate-boxr">
                    <div class="rd-accurate-boxr-box">
                        <div>推荐商品</div>
                        <img style="margin-top: 30px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-accurate-r2.png" alt="">
                        <img class="rd-accurate-r1" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-accurate-r1.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "retail-digitization",
        data:vm=>{
            return{
                index:0,
                isfiex:false,
                swiperOptions: {
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    slidesPerView: 1,
                    centeredSlides: true,
                    observer: true,
                    observeParents: true,
                    on:{
                        slideNextTransitionStart: function () {
                        },
                        slidePrevTransitionStart: function () {
                        },
                    }
                },
            }
        },
        methods:{
            // 保存滚动值，这是兼容的写法
            handleScroll () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                // console.log(scrollTop);
                if(scrollTop>1430){
                    this.isfiex = true
                }else {
                    this.isfiex = false
                }
                if(scrollTop<2400){
                    this.index = 0
                }
                if(scrollTop>2400 && scrollTop<3200){
                    this.index = 1
                }
                if(scrollTop>3200 && scrollTop<4170){
                    this.index = 2
                }
                if(scrollTop>4170 && scrollTop<5000){
                    this.index = 3
                }
                if(scrollTop>5000){
                    this.index = 4
                }
            },
        },
        mounted() {
            // this.swiper.slideTo(3, 1000, false)
            window.addEventListener('scroll', this.handleScroll, true)
            console.log("%c所有的结尾都已经写好，\n所有的泪水都已经启程。\n却突然忘记那是一个怎样的开始，\n在那个古老的不在回来的夏日。\n\n","color:#558058");
        }
    }
</script>

<style lang="less" scoped>
.b-banner-box{
        margin-top: 7px;
        width: 100%;
        height: 322px;
        background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-banner.png") center center no-repeat;
        -webkit-background-size: auto 100%;
        background-size: auto 100%;
        display: flex;
        align-items: flex-end;
        margin-bottom: 50px;
        .b-banner-titlebg{
            width: 100%;
            height: 80px;
            background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/baner-tbg.png") center center no-repeat;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            .b-banner-title{
                width: 1200px;
                height: 80px;
                font-size: 40px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
            }
        }
    }

.rd-title{
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 32px;
    text-align: center;
}
.rd-title2{
    font-size: 20px;
    text-align: center;
    margin-bottom: 5px;
}
.rd-title3{
    font-size: 30px;
    font-weight: bold;
    text-align: center;
}
.rd-channel1-box{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .rd-channel1-boxc{
        width: 163px;
        height: 164px;
        background: #434343;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        color: #fff;
        transition: all .3s linear;
        .rd-channel1-boxcimg{
            width: 32px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
        }
        .rd-channel1-hoverBox{
            width: 100%;
            height: 100%;
            background: #D02024;
            position: absolute;
            left: 0;
            top: -100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: #FFFFFF;
            transition: all .2s linear;
            .rd-channel1-hoverBoxc{
                width: 110px;
                height: 26px;
                background: #FFFFFF;
                border-radius: 13px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
                color: #000;
                margin-bottom: 8px;
            }
        }
        .rd-channel1-z{
            transform-style: preserve-3d;
            backface-visibility:hidden;
            transition:all .5s;
            transform:rotateY(0deg);
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .rd-channel1-f{
            transform-style: preserve-3d;
            backface-visibility:hidden;
            transition:all .5s;
            transform:rotateY(-180deg);
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
    .rd-channel1-boxc:hover .rd-channel1-z{
        transform:rotateY(-180deg);
    }
    .rd-channel1-boxc:hover .rd-channel1-f{
        transform:rotateY(0deg);
    }
    .rd-channel1-boxc:hover .rd-channel1-hoverBox{
        top: 0;
    }
}
.rd-unified-box{
    width: 1025px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto 90px auto;
}
.rd-tabbgf{
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    a{
        text-decoration: none;
        color: #000;
    }
    .rd-tabbg{
        width: 100%;
        height: 50px;
        background: #fff;
        border-bottom: 1px solid #E5E5E5;
        display: flex;
        justify-content: center;
        align-items: center;
        .rd-tab{
            padding-top: 12px;
            box-sizing: border-box;
            width: 1025px;
            height: 50px;
            display: flex;
            justify-content: space-around;
            align-items: flex-start;
            .rd-tabc{
                height: 100%;
                position: relative;
                cursor: pointer;
                .rd-tabcline{
                    width: 90%;
                    position: absolute;
                    left: 5%;
                    bottom: 0;
                    height: 6px;
                    background: #D02024;
                    border-radius: 3px;
                    display: none;
                }
            }
            .rd-tabc-s{
                color: #D02024 !important;
                display: block !important;
            }
            .rd-tabc:hover{
                color: #D02024;
            }
            .rd-tabc:hover .rd-tabcline{
                display: block;
            }
        }
    }
    .isfiex{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
    }
}
.rd-swiper{
    margin-top: 70px;
    margin-bottom: 190px;
    position: relative;
    .rd-swiper-slide{
        width: 100%;
        height: 608px;
        position: relative;
        .rd-swiper-slide-l{
            width: 845px;
            height: 608px;
            background: url('https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/rd-member-rt.png') no-repeat;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding-right: 120px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: center;
            .rd-swiper-slide-l-title{
                position: relative;
                z-index: 2;
                width: 360px;
                display: flex;
                justify-content: flex-start;
                font-size: 40px;
                font-weight: bold;
                color: #FFFFFF;
                margin-bottom: 19px;
            }
            .rd-swiper-slide-l-title2{
                position: relative;
                z-index: 2;
                width: 360px;
                display: flex;
                justify-content: flex-start;
                font-size: 20px;
                font-weight: 400;
                color: #FFFFFF;
            }
            .rd-swiper-slide-l-info{
                position: relative;
                z-index: 2;
                left: 20px;
                margin-top: 50px;
                width: 350px;
                padding-left: 30px;
                .rd-swiper-slide-l-infoc{
                    font-size: 20px;
                    color: #FFFFFF;
                    margin-bottom: 10px;
                }
                .rd-swiper-slide-l-line{
                    width: 1px;
                    height: 76%;
                    position: absolute;
                    top: 10px;
                    left: 0;
                    background: #FFFFFF;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: space-between;
                    .rd-swiper-slide-l-r{
                        width: 14px;
                        height: 14px;
                        background: rgba(220, 6, 22, .38);
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .rd-swiper-slide-l-rn{
                            width: 8px;
                            height: 8px;
                            background: #DC0616;
                            border-radius: 50%;
                        }
                    }
                }
            }
        }
        .rd-swiper-slide-r{
            width: 1206px;
            height: 491px;
            background: #DC0616;
            position: absolute;
            top: 50%;
            left: 749px;
            margin-top: -245px;
            box-sizing: border-box;
            padding-left: 58px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .rd-swiper-slide-rdpc{
                display: flex;
                .rd-swiper-slide-c{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    font-size: 20px;
                    font-weight: 500;
                    color: #FFFFFF;
                    margin-right: 60px;
                }
            }
        }
    }
    .rd-member-prve{
        position: absolute;
        top: 50%;
        margin-top: -32px;
        left: 100px;
        z-index: 99;
        cursor: pointer;
    }
    .rd-member-next{
        position: absolute;
        top: 50%;
        margin-top: -32px;
        right: 100px;
        z-index: 99;
        cursor: pointer;
    }
}
.rd-integral{
    .rd-integral-c{
        width: 1200px;
        margin: 90px auto 28px auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .rd-integral-c-box{
            width: 222px;
            height: 243px;
            border: 1px solid #BCBCBC;
            border-radius: 10px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 20px;
            .rd-integral-c-boximg{
                width: 55px;
                height: 55px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 35px;
                .rd-integral-c-boximg-show{
                    display: block;
                }
                .rd-integral-c-boximg-show2{
                    display: none;
                }
            }
        }
        .rd-integral-c-box:hover .rd-integral-c-boximg-show{
            display: none;
        }
        .rd-integral-c-box:hover .rd-integral-c-boximg-show2{
            display: block;
        }
    }
    .rd-integral-c2{
        margin-top: 0;
        width: 1000px;
        justify-content: space-around !important;
    }
}
.rd-coupon{
    .rd-coupon-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        margin: 148px auto 0 auto;
        .rd-coupon-boxc{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 20px;
            .rd-coupon-boxcimg{
                margin-bottom: 29px;
            }
        }
    }

}

.rd-promotion{
    .rd-promotion-tbox{
        width: 660px;
        margin: 140px auto 20px auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .rd-promotion-tboxc{
            width: 105px;
            height: 61px;
            background: #8596BC;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            color: #fff;
            .rd-promotion-tboximg{
                width: 32px;
                height: 32px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
    .rd-promotion-tbox-title{
        text-align: center;
        font-size: 18px;
    }
    .rd-promotion-infobox{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1240px;
        margin: 0 auto;
        position: relative;
        left: -65px;
        .rd-promotion-infobox-l{
            font-size: 24px;
            font-weight: bold;
            color: #1C1C1C;
            text-align: center;
            margin-right: 23px;
        }
        .rd-promotion-infobox-m{
            width: 671px;
            height: 208px;
            background: #D02024;
            border-radius: 5px;
            padding: 19px;
            .rd-promotion-infobox-m-title{
                font-size: 18px;
                color: #FFFFFF;
                margin-bottom: 15px;
            }
            .rd-promotion-infobox-m-cbox{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 12px;
                .rd-promotion-infobox-m-c{
                    width: 147px;
                    height: 38px;
                    background: #FFFFFF;
                    border-radius: 5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    color: #2D2D2D;
                }
                .rd-promotion-infobox-m-c2{
                    width: 322px;
                    height: 38px;
                    background: #FFFFFF;
                    border-radius: 5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    color: #2D2D2D;
                }
            }
        }
    }
    .rd-promotion-infob{
        width: 1240px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        .rd-promotion-infob-box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .rd-promotion-infob-boxtext{
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 20px;
            }
        }
    }
}

.rd-accurate{
    .rd-accurate-box{
        display: flex;
        width: 1200px;
        margin: 0 auto 70px auto;
        .rd-accurate-boxl{
            width: 730px;
            display: flex;
            justify-content: center;
            flex-wrap:wrap;
        }
        .rd-accurate-boxr{
            padding-left: 100px;
            position: relative;
            .rd-accurate-boxr-box{
                position: relative;
                width: 346px;
                height: 530px;
                border: 1px solid #DCDCDC;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                font-weight: bold;
                .rd-accurate-r1{
                    position: absolute;
                    top: 50%;
                    margin-top: -58px;
                    left: -110px;
                }
            }
        }
    }
}
</style>